import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const reportingSessionPaymentsDetailsAPI = async (params: {
  sessionId: string;
  format: string;
}) => {
  const response = await baseAPI.get<string>(
    '/reporting/session-payments-details',
    {
      params,
      responseType: 'text',
    },
  );
  return response.data;
};

export const useReportingSessionPaymentsDetails = (params: {
  sessionId: string;
  format: string;
}) => {
  return useQuery({
    queryKey: [KEYS.SESSION_PAYMENTS_DETAILS, params.sessionId, params.format],
    queryFn: () => reportingSessionPaymentsDetailsAPI(params),
    enabled: !!params.sessionId && !!params.format,
  });
};
